export default {
  List: {
    Title: 'Nguồn kinh phí',
    DictionaryActivity: '/ Mục lục ngân sách / Nguồn kinh phí',
    Dictionary: 'Danh mục',
    TextPlaceholder: {
      Search: 'Tìm kiếm theo Mã nguồn, Tên nguồn, TCN,...',
    },
    BudgetSource: 'Chuyển nguồn',
    BudgetSourceSwitching: 'Chuyển nguồn hạch toán',
    ShowMessage: {
      FirstMessage: 'Nguồn kinh phí <span class="color-green">',
      LastMessage: '</span> đã phát sinh dữ liệu. Bạn cần chuyển dữ liệu phát sinh vào nguồn cha để xóa nguồn này.',
      Title: 'Xóa nguồn kinh phí',
    },
    ConfirmDelete: {
      First: 'Bạn có thực sự muốn xóa nguồn <span class="color-green"> ',
      Last: '</span> không?',
    },
    ShowMessageDeleteMulti: {
      FirstMessage: 'Nguồn <span class="color-green">',
      SecondMessage:
        '</span> đã phát sinh dữ liệu vào nguồn chi tiết. Dữ liệu phát sinh vào nguồn chi tiết sẽ chuyển sang nguồn <span class="color-green">',
      ThirdMessage: '</span>. Bạn có muốn thực hiện không?',
      Title: 'Xóa nguồn tổng hợp',
      BtnYes: 'Đồng ý',
      BtnNo: 'Hủy',
    },
    DeleteAllBudgetSourceChilds: 'Xóa tất cả nguồn con',
    ShowMessageIsSystem: {
      FirstMessage: 'Nguồn <span class="color-green">',
      LastMessage: '</span> thuộc danh mục hệ thống. Bạn không thể thực hiện chức năng này.',
      Title: 'Xóa không thành công',
      Button: 'Đồng ý',
    },
  },
  Detail: {
    Text: {
      BudgetSourceCode: 'Mã nguồn kinh phí *',
      BudgetSourceName: 'Tên nguồn kinh phí *',
      BudgetSource: 'Thuộc nguồn kinh phí',
      BudgetSourceProperty: 'Tính chất',
      GovSourceCode: 'Mã nguồn NSNN',
      BudgetDistribution: 'Mã số cấp NS',
    },
    TextTooltip: {
      GovSourceCode: 'Mã nguồn ngân sách nhà nước',
      BudgetDistribution: 'Mã số cấp ngân sách',
    },
    Enum: {
      m0: '0',
      m01: '01',
      m50: '50',
      m1: '1',
      m00: 0,
      m001: 1,
      m050: 50,
    },
  },
  BudgetTransfer: {
    Title: 'Chuyển Nguồn kinh phí',
    Text: {
      BudgetSource: 'Chức năng này giúp bạn chuyển toàn bộ dữ liệu gắn với nguồn',
      BudgetSource1: 'vào nguồn',
      BudgetSource2: 'Chuyển từ nguồn',
      BudgetSource3: 'Chuyển đến nguồn',
      Option: 'Tùy chọn',
      Surplus: 'Chuyển số dư',
      Dictionary: 'Chuyển dự toán',
      License: 'Chuyển phát sinh',
      Time: 'Thời gian',
      FromLabel: 'Từ ngày',
      ToLabel: 'Đến ngày',
      DeleteAfter: 'Xóa nguồn sau khi chuyển',
      Excution: 'Thực hiện',
    },
  },
  ShowAlertConfirm: {
    ChangeToParent: `Bạn đang chọn nguồn chuyển đến là nguồn tổng hợp <span class="bold color-green"> {0}</span>, để thực hiện chuyển nguồn hạch toán cho nguồn này bạn phải chọn xóa nguồn sau khi chuyển và chuyển nguồn chuyển đi gồm tất cả nguồn chi tiết của nguồn <span class="bold color-green"> {1}</span>.`,
    ChangeToParentOther: `Bạn đang chọn nguồn chuyển đến là nguồn tổng hợp <span class="bold color-green"> {0}</span>, để thực hiện chuyển nguồn cho nguồn này bạn phải chọn xóa nguồn chi tiết của nguồn <span class="bold color-green"> {1}</span>.`,
    License: 'Bạn chưa chọn tiêu chí cần chuyển.',
    CheckDuplicate:
      "<span class='color-green'>Chuyển từ nguồn</span> và <span class='color-green'>Chuyển đến nguồn</span> không được phép trùng nhau.",
    ChooseBudget:
      "Vui lòng chọn 1 giá trị <span class='color-green'>Chuyển đến nguồn</span> trước khi thực hiện chuyển nguồn.",
    SelectBudget: "Bạn phải chọn ít nhất một nguồn trên danh sách <span class='color-green'>Chuyển từ nguồn</span>.",
    ErrorDeleteMutiple: `Nguồn <span class='color-green'>{0}</span> là dữ liệu thuộc hệ thống.`,
    ErrorDelete: `<span class='color-green'>{0}</span> là dữ liệu thuộc hệ thống.`,
    Success: 'Chuyển nguồn thành công',
    StartsWith: 'Mã nguồn kinh phí con phải bắt đầu bằng mã nguồn kinh phí cha.',
    ErrorStartsWith: 'Mã nguồn kinh phí không hợp lệ',
    BelongingChilde: `Không được chọn Nguồn kinh phí <span class="color-green">{0}</span> thuộc chính nó`,
    ErrorBelongingChilde: 'Không hợp lệ',
    ValidateSelectChild: 'Nguồn kinh phí tổng hợp không hợp lệ. Vui lòng kiểm tra lại.',
    BudgetSource: 'Nguồn kinh phí',
    ErrorValidate:
      'Nguồn <span class="color-green">{0}</span> đã phát sinh dữ liệu. Vui lòng bỏ chọn <span class="color-green">Xóa nguồn sau khi chuyển</span> để tiếp tục thực hiện.',
    TitleErrorValidate: 'Xóa không thành công',
    ToastSuccess: 'Cất dữ liệu thành công',
    ToastError: 'Cất dữ liệu không thành công',
  },
};
